import React, { useState, useEffect } from "react";
import {
    Container,
    Card,
    Table,
    Pagination,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getBankAccount, approveBankAccount } from "../../store/slices/user";

export default function AdminBanklist() {
    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const limit = 20;


    useEffect(() => {
        dispatch(getBankAccount());
    }, [dispatch]);

    const {
        bankAccount = [],
        loading,
    } = useSelector((state) => state.user);

    const banklist = bankAccount;

    const totalPages = Math.ceil(banklist.length / limit);

    const paginatedData = banklist.slice(
        (page - 1) * limit,
        page * limit
    );

    const buildPages = () => {
        const pages = [];

        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }

        return pages;
    };
    const handleApprove = async (bankAccountId) => {
        const confirmed = window.confirm(
            "Are you sure you want to approve this bank account?"
        );

        if (!confirmed) return;

        try {
            const response = await dispatch(
                approveBankAccount({
                    bankAccountId,
                })
            ).unwrap();

            toast.success(
                response?.message ||
                "Bank account approved successfully"
            );

            dispatch(getBankAccount());
        } catch (error) {
            toast.error(
                error || "Failed to approve bank account"
            );
        }
    };
    return (
        <>
            <div className="breadcrumb-bar mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-row align-items-center justify-content-between gap-2 py-2">
                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link
                                to="/admin/home"
                                className="breadcrumb-link active my-2"
                            >
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span className="breadcrumb-link inactive">
                                Bank Account Details
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ud-page-wrap">
                <Container fluid>
                    <div className="ud-header">
                        <h2 className="ud-main-title">
                            Bank Account Details
                        </h2>
                    </div>

                    <Card className="ud-table-card">
                        <Card.Body className="p-0">
                            <div className="ud-scroll-wrap">
                                <Table
                                    hover
                                    borderless
                                    className="ud-table align-middle mb-0"
                                >
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>User</th>
                                            <th>Account Details</th>
                                            <th>Added On</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paginatedData.length > 0 ? (
                                            paginatedData.map((b, idx) => (
                                                <tr key={b._id}>
                                                    <td>
                                                        {(page - 1) * limit +
                                                            idx +
                                                            1}
                                                    </td>
                                                    <td>{b?.userId?.name}</td>

                                                    <td>
                                                        <div>
                                                            <strong>{b.bankName}</strong>
                                                        </div>

                                                        <div>
                                                            A/C: {b.accountNumber}
                                                        </div>

                                                        <div>
                                                            Holder: {b.accountHolderName}
                                                        </div>

                                                        <div>
                                                            IFSC: {b.ifscCode}
                                                        </div>

                                                        <div>
                                                            Type: {b.accountType}
                                                        </div>
                                                    </td>

                                                    <td>
                                                        {b.createdAt
                                                            ? new Date(b.createdAt).toLocaleDateString("en-GB")
                                                            : "-"}
                                                    </td>

                                                    <td>
                                                        <span
                                                            className={`badge ${b.isVerified
                                                                ? "bg-success"
                                                                : "bg-warning text-dark"
                                                                }`}
                                                        >
                                                            {b.isVerified
                                                                ? "Verified"
                                                                : "Pending Approval"}
                                                        </span>
                                                    </td>
                                                    <td className="d-flex justify-content-center align-items-center">
                                                        <button
                                                            className="global-login-btn px-3 py-1"
                                                            onClick={() => handleApprove(b._id)}
                                                            disabled={loading}
                                                        >
                                                            Approve
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="9"
                                                    className="text-center py-4"
                                                >
                                                    No Pending Bank Details Found!
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>

                    {totalPages > 1 && (
                        <div className="ud-pagination-wrap">
                            <Pagination className="ud-pagination mb-5">
                                <Pagination.Prev
                                    disabled={page === 1}
                                    onClick={() =>
                                        setPage(page - 1)
                                    }
                                />

                                {buildPages().map((p) => (
                                    <Pagination.Item
                                        key={p}
                                        active={page === p}
                                        onClick={() => setPage(p)}
                                    >
                                        {p}
                                    </Pagination.Item>
                                ))}

                                <Pagination.Next
                                    disabled={page === totalPages}
                                    onClick={() =>
                                        setPage(page + 1)
                                    }
                                />
                            </Pagination>
                        </div>
                    )}
                </Container>
            </div>
        </>
    );
}